import { CropperModalContent } from './CropperModalContent';

export const CropperModal = (): JSX.Element => (<CropperModalContent />);
